<template>
  <div>
    <v-text-field
      :label="label"
      :placeholder="placeholder"
      :solo="solo"
      :clearable="clearable"
      :solo-inverted="soloInverted"
      :color="color"
      :filled="filled"
      :loading="loading"
      :disabled="disabled"
      :dense="dense"
      :style="localStyle"
      :class="classes"
      hide-details="auto"
      :append-outer-icon="iconAppend ? undefined : searchIcon"
      :append-icon="iconAppend ? searchIcon : undefined"
      v-model="search"
      @focus="expand"
      @blur="collapse"
      @keydown="keydown"
      @click:append="clickOnIcon"
      @click:append-outer="clickOnIcon"
    ></v-text-field>
  </div>
</template>

<script>
// new version
import emittable from '../../mixins/emittable'

import {
  VTextField
} from 'vuetify/lib'

export default {
  name: "SearchBar",
  components: {
    VTextField
  },
  mixins: [emittable],
  data: function() {
    let ls = { ...this.styles }
    if(!ls['width']) {
      ls['width'] = '300px'
    }

    return {
      search: this.value,
      localStyle: ls
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Search ...'
    },
    solo: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    dense: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'primary'
    },
    filled: {
      type: Boolean,
      default: true
    },
    iconAppend: {
      type: Boolean,
      default: false
    },
    searchIcon: {
      type: String,
      default: 'mdi-text-search'
    },
    soloInverted: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    searchOnEnter: {
      type: Boolean,
      default: true
    },
    searchOnIconClick: {
      type: Boolean,
      default: true
    },
    expandOnFocus: {
      type: Boolean,
      default: false
    },
    styles: {
      type: Object,
      default: function() {
        return {
          'width': '300px'
        }
      }
    },
    classes: {
      type: Object,
      default: function() {
        return {
        }
      }
    }
  },
  methods: {
    keydown(event) {
      if(event.keyCode == 13 && this.searchOnEnter) {
        this.emit('search', this.search)
      } else {
        this.emit('key-down')
      }
    },
    clickOnIcon() {
      if(this.searchOnIconClick) {
        this.emit('search', this.search)
      }
    },
    expand() {
      let width = this.localStyle['width']
      let finalWidth = width;
      if(this.expandOnFocus) {
        if(width.includes('px')) {
          finalWidth = parseInt(width.substring(0, width.length - 2)) + 100
          finalWidth = finalWidth + 'px'
        }
      }

      this.localStyle['transition'] = "width 0.3s"
      this.localStyle['width'] = finalWidth
    },
    collapse() {
      let width = this.localStyle['width']
      let finalWidth = width;
      if(this.expandOnFocus) {
        if(width.includes('px')) {
          finalWidth = parseInt(width.substring(0, width.length - 2)) - 100
          finalWidth = finalWidth + 'px'
        }
      }

      this.localStyle['transition'] = "width 0.3s"
      this.localStyle['width'] = finalWidth
    }
  },
  watch: {
    search: function(newVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>

<style>

</style>